<p-messages [showTransitionOptions]="'2000ms'" [hideTransitionOptions]="'4ms'" severity="error">
  <ng-template pTemplate>
      <fa-icon class="icon" [icon]="'exclamation-circle'"></fa-icon>
      <div class="p-ml-2">
        <span> <b>  {{ titleMessage }} </b> {{ textMessage }} <a (click)="closeModal()" class="color-link" [routerLink]="link"> {{ msgAction }} </a></span>
      </div>
  </ng-template>
</p-messages>
